import React from 'react';
import {map} from 'lodash';
import Page from 'components/acommon/Page';
import {AddressSection, CaseHeader, CaseRecommendations, DatesAndGuests} from '../shared';
import {StyledPage} from '../styled';
import {
  CaseBody,
  Image,
  RoundBadges,
  PriceButtons,
  Price,
  OrderForm,
  Col,
  Row,
  ExperienceProperty,
  // IncludedItem,
} from './styled';
import image from '../../../assets/img/event.jpg';
import StyledIcon from 'components/acommon/StyledIcon';
import Button, {ButtonWithPrice, DesktopBackButton} from 'components/Button';
import {ModalDateAndNumber} from '../ModalDateAndNumber';
import {ModalReceiveTicket} from '../ModalReceiveTicket';

const list = [
  {
    date: 'Tue, May 30',
    time: '7:30 AM - 7:30PM',
    price: 25,
  },
  {
    date: 'Tue, May 31',
    time: '7:30 AM - 7:30PM',
    price: 18,
  },
  {
    date: 'Tue, May 32',
    time: '7:30 AM - 7:30PM',
    price: 10,
  },
  {
    date: 'Tue, May 33',
    time: '7:30 AM - 7:30PM',
    price: 6,
  },
];

function EventCase() {
  const [isOpenModalDateAndNumber, setOpenModalDateAndNumber] =
    React.useState<boolean>(false);
  const [isOpenModalReceiveTicket, setOpenModalReceiveTicket] =
    React.useState<boolean>(false);

  const handleModalDateAndNumber = () => {
    setOpenModalDateAndNumber(!isOpenModalDateAndNumber);
  };
  const handleModalReceiveTicket = () => {
    setOpenModalReceiveTicket(!isOpenModalReceiveTicket);
  };

  return (
    <Page>
      <ModalDateAndNumber
        isOpenModalDateAndNumber={isOpenModalDateAndNumber}
        handleModalDateAndNumber={handleModalDateAndNumber}
        handleModalReceiveTicket={handleModalReceiveTicket}
      />
      <ModalReceiveTicket
        isOpenModalReceiveTicket={isOpenModalReceiveTicket}
        handleModalReceiveTicket={handleModalReceiveTicket}
      />
      <StyledPage>
        <DesktopBackButton />
        <CaseHeader title="Piero Matuzzi in ´More Than Jazz´ concert" />
        <CaseBody>
          <Col style={{maxWidth: '620px'}}>
            <Image
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
            <Col className="paragraph">
              <div className="subTitle">Amazing Experience</div>

              <RoundBadges>
                <ExperienceProperty>
                  <StyledIcon name="circleTimeIcon" size="46" />
                  <div className="property">Get in from 10:00 am</div>
                </ExperienceProperty>
                {/* <ExperienceProperty>
                    <StyledIcon name="circlePeopleIcon" size="46" />
                    <div className="property">Up to 4 people</div>
                  </ExperienceProperty> */}

                {/* <ExperienceProperty>
                    <StyledIcon name="circleLanguageIcon" size="46" />
                    <div className="property">Hosted in English, Spanish</div>
                  </ExperienceProperty> */}
              </RoundBadges>
            </Col>
            <Col className="paragraph">
              <div className="subTitle">Activity</div>
              <div className="text18">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed eiusmod
                tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                quis nostrud exercitation ullamco laboris nisi ut aliquid ex ea commodi
                consequat. Quis aute iure reprehenderit in voluptate velit esse cillum
                dolore eu fugiat nulla pariatur. Excepteur sint obcaecat cupiditat.
              </div>
            </Col>
            <Col className="paragraph">
              <AddressSection address={'Charitépl. 1, 10117 Berlin, Germany'} />
            </Col>

            {/* <Col className="paragraph">
              <div className="subTitle">What's included</div>
              <RoundBadges className="text18">
                <IncludedItem color="#dceef7">
                  <Row className="includedIcon">
                    <StyledIcon name="includedTicket" size="32" />
                  </Row>
                  <Row className="includedName">Tickets</Row>
                  <Row className="includedDesc">
                    Delicious food picnic lunch. Please let us know if you have any
                    dietary...
                  </Row>
                </IncludedItem>
                <IncludedItem color="#e6dbff">
                  <Row className="includedIcon">
                    <StyledIcon name="includedDrinks" size="32" />
                  </Row>
                  <Row className="includedName">Drinks</Row>
                  <Row className="includedDesc">
                    Delicious food picnic lunch. Please let us know if you have any
                    dietary...
                  </Row>
                </IncludedItem>
                <IncludedItem color="#ffcef2">
                  <Row className="includedIcon">
                    <StyledIcon name="includedHealth" size="32" />
                  </Row>
                  <Row className="includedName">Health pack</Row>
                  <Row className="includedDesc">
                    Delicious food picnic lunch. Please let us know if you have any
                    dietary...
                  </Row>
                </IncludedItem>
                <IncludedItem color="#c7f3dc">
                  <Row className="includedIcon">
                    <StyledIcon name="includedFood" size="32" />
                  </Row>
                  <Row className="includedName">Food</Row>
                  <Row className="includedDesc">
                    Delicious food picnic lunch. Please let us know if you have any
                    dietary...
                  </Row>
                </IncludedItem>
              </RoundBadges>
            </Col> */}
          </Col>
          <Col style={{width: '100%', maxWidth: '440px'}}>
            <OrderForm>
              <Price>
                <div className="textPrice">From</div>
                <div className="newprice">&nbsp;{`$${6}`}&nbsp;</div>
                <div className="textPrice"> / room</div>
              </Price>
              <Row>
                <DatesAndGuests />
              </Row>
              <Col>
                {map(list, (item, index) => {
                  return (
                    <PriceButtons key={index}>
                      <Col>
                        <div className="scheduleDate">{item.date}</div>
                        <div className="scheduleTime">{item.time}</div>
                      </Col>
                      <Col>
                        <ButtonWithPrice
                          label={'/ person'}
                          price={`$${item.price}`}
                          icon="shoppingBagIcon"
                        />
                      </Col>
                    </PriceButtons>
                  );
                })}
              </Col>
              <Row className="moreDates">See more dates</Row>
              <Row style={{justifyContent: 'center'}}>
                <Button
                  label="Request Experience"
                  iconRight="shoppingBagIcon"
                  short
                  onClick={handleModalDateAndNumber}
                />
              </Row>
            </OrderForm>
          </Col>
        </CaseBody>
        <CaseRecommendations />
      </StyledPage>
    </Page>
  );
}

export default EventCase;
